import { FilledInputProps, InputProps, OutlinedInputProps, TextField } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

export enum UpdateOn {
    Blur = "blur",
    Change = "change",
}

const MoneyInputField: React.FunctionComponent<{
    label: string,
    value?: number;
    updateOn?: UpdateOn;
    readOnly?: boolean;
    maxWidth?: number;
    testId?: string;
    inputProps?: Partial<InputProps> | Partial<FilledInputProps> | Partial<OutlinedInputProps> | undefined;
    error?: boolean | undefined;
    onChange?: (value: number) => void;
}> = (props) => {
    const ref = useRef<HTMLInputElement>();

    const formatValue = (value: number | string | null | undefined) => {
        return parseFloat((value == null ? "0" : value.toString())).toFixed(2);
    }

    const handleUpdate = () => {
        const value = parseFloat(ref.current?.value || "0");
        if (!props.onChange || isNaN(value)) {
            return;
        }

        props.onChange(value);
    }

    const [value, setValue] = useState<string>(formatValue(props.value));

    useEffect(() => {
        const formattedValue = formatValue(value || null);
        const newValue = formatValue(props.value);

        if (formattedValue !== newValue) {
            setValue(newValue);
        }
    }, [props.value]);

    const updateOn = props.updateOn ?? UpdateOn.Blur;

    return (
        <TextField
            data-testid={props.testId}
            inputRef={ref}
            type="number"
            size="small"
            disabled={props.readOnly}
            label={props.label}
            variant="outlined"
            error={props.error}
            style={
                {
                    maxWidth: props.maxWidth,
                    padding: '3px 3px',
                }
            }
            value={value}
            InputLabelProps={{ shrink: true }}
            InputProps={props.inputProps}
            onChange={() => {
                setValue(ref.current?.value ?? "0");

                if (updateOn === UpdateOn.Change) {
                    handleUpdate();
                }
            }}
            onBlur={() => {
                setValue(formatValue(ref.current?.value || null));

                if (updateOn === UpdateOn.Blur) {
                    handleUpdate();
                }
            }}
        />
    );
}

export default MoneyInputField;
